// extracted by mini-css-extract-plugin
export default {"projectWrapper":"project_projectWrapper__TX+ER","projectBackground":"project_projectBackground__GIR1S","projectTop":"project_projectTop__oUHzL"};